@if ({
  overview: overview$ | async,
  errorOverview: errorOverview$ | async
  }; as type) {
  <!-- Filter and search -->
  <div class="cx-order-history-filter">
    <div class="form-group row">
      <label for="orders" class="col-xl-2 col-form-label">{{
        'customOrderHistory.search.orders' | cxTranslate
      }}</label>
      <ng-select
        id="orders"
        class="col-xl-2"
        [searchable]="false"
        [clearable]="false"
        (change)="onChangeFilter()"
        [(ngModel)]="selectedFilterOption"
        >
        @for (filter of filterOptions; track filter) {
          <ng-option [value]="filter">{{
            'customOrderHistory.filter.' + filter | cxTranslate
          }}</ng-option>
        }
      </ng-select>
    </div>
    <form (ngSubmit)="onSubmit()" #f="ngForm" autocomplete="off">
      @if (showDefault) {
        <div class="form-group row">
          <label for="orderDateFrom" class="col-xl-2 col-form-label">{{
            'customOrderHistory.search.orderDateFrom' | cxTranslate
          }}</label>
          <div class="col-xl-2">
            <input
              type="date"
              id="orderDateFrom"
              class="form-control"
              [(ngModel)]="orderDateFrom"
              name="orderDateFrom"
              [(value)]="orderDateFrom"
              min="{{ orderDateFromMin }}"
              max="{{ orderDateFromMax | date: 'yyyy-MM-dd' }}"
              (change)="changeOrderDateFrom($event)"
              />
            </div>
            <label for="orderDateTo" class="col-xl-2 col-form-label">{{
              'customOrderHistory.search.orderDateTo' | cxTranslate
            }}</label>
            <div class="col-xl-2">
              <input
                type="date"
                id="orderDateTo"
                class="form-control"
                [(ngModel)]="orderDateTo"
                name="orderDateTo"
                [(value)]="orderDateTo"
                min="{{ orderDateToMin }}"
                max="{{ orderDateToMax | date: 'yyyy-MM-dd' }}"
                (change)="changeOrderDateTo($event)"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="uigOrderNumber" class="col-md-2 col-form-label">{{
                'customOrderHistory.search.uigOrderNumber' | cxTranslate
              }}</label>
              <div class="col-md-2">
                <input
                  type="text"
                  id="uigOrderNumber"
                  class="form-control"
                  [(ngModel)]="uigOrderNumber"
                  name="uigOrderNumber"
                  [value]="uigOrderNumber"
                  />
                </div>
                <label for="productCode" class="col-md-2 col-form-label">{{
                  'customOrderHistory.search.productCode' | cxTranslate
                }}</label>
                <div class="col-md-2">
                  <input
                    type="text"
                    id="productCode"
                    class="form-control"
                    [(ngModel)]="productCode"
                    name="productCode"
                    [value]="productCode"
                    />
                  </div>
                </div>
              }
              @if (!showDefault) {
                <div class="form-group row">
                  <label for="searchFor" class="col-md-2 col-form-label">{{
                    'customOrderHistory.search.searchFor' | cxTranslate
                  }}</label>
                  <div class="col-md-4">
                    <input
                      type="text"
                      id="searchFor"
                      class="form-control"
                      [(ngModel)]="searchFor"
                      name="searchFor"
                      [value]="searchFor"
                      />
                    </div>
                    <label for="searchFor" class="col-md-6 col-form-label">{{
                      'customOrderHistory.search.searchForText' | cxTranslate
                    }}</label>
                  </div>
                }
                <div class="form-group row">
                  <div class="col-sm-4">
                    <button class="btn btn-secondary btn-block mb-3" type="submit">
                      {{ 'customOrderHistory.buttons.search' | cxTranslate }}
                    </button>
                  </div>
                  <div class="col-sm-4">
                    <button class="btn btn-secondary btn-block mb-3" type="reset" (click)="onReset()">
                      {{ 'customOrderHistory.buttons.reset' | cxTranslate }}
                    </button>
                  </div>
                  <div class="col-sm-4">
                    @if (!errorOverview && overview?.pagination?.totalResults > 0) {
                      <button
                        class="btn btn-secondary btn-block mb-3"
                        type="button"
                        (click)="onExport()"
                        >
                        {{ 'customOrderHistory.buttons.export' | cxTranslate }}
                      </button>
                    }
                  </div>
                </div>
              </form>
            </div>
            @if (!errorOverview && overview && overview.pagination?.totalResults > 0) {
              <div
                class="cx-order-history-sort"
                >
                <div class="form-group row">
                  <label for="orders" class="col-xl-2 col-form-label">{{
                    'customOrderHistory.sortOptions.label' | cxTranslate
                  }}</label>
                  <ng-select
                    id="sortOptions"
                    class="col-xl-2"
                    [searchable]="false"
                    [clearable]="false"
                    (change)="onChangeSort()"
                    [(ngModel)]="selectedSortOption"
                    >
                    @for (sort of sortOptions; track sort) {
                      <ng-option [value]="sort">{{
                        'customOrderHistory.sortOptions.' + sort | cxTranslate
                      }}</ng-option>
                    }
                  </ng-select>
                  <label for="sortDirections" class="col-xl-2 col-form-label">{{
                    'customOrderHistory.sortDirections' | cxTranslate
                  }}</label>
                  <div class="col-xl-2 col-form-label">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="sortDirection"
                        id="sortDirectionDesc"
                        value="desc"
                        ng-control="sortDirection"
                        [(ngModel)]="sortDirection"
                        (change)="onChangeSort()"
                        />
                        <label class="form-check-label" for="sortDirectionDesc">
                          {{ 'customOrderHistory.sortDirection.desc' | cxTranslate }}
                        </label>
                      </div>
                    </div>
                    <div class="col-xl-2 col-form-label">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="sortDirection"
                          id="sortDirectionAsc"
                          value="asc"
                          ng-control="sortDirection"
                          [(ngModel)]="sortDirection"
                          (change)="onChangeSort()"
                          />
                          <label class="form-check-label" for="sortDirectionAsc">
                            {{ 'customOrderHistory.sortDirection.asc' | cxTranslate }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                @if (overview || errorOverview) {
                  <div [ngClass]="container">
                    <!-- BODY -->
                    <div class="cx-order-history-body">
                      @if (
                        !errorOverview && overview?.pagination?.totalResults > 0) {
                        <!-- REMAINS table view -->
                        @if (!showDefault) {
                          <app-custom-order-history-overview-table-remains
                            [entries]="orderEntries"
                          ></app-custom-order-history-overview-table-remains>
                        }
                        <!-- ------------------------------ -->
                        <!-- OVERVIEW/OPEN (default) table view -->
                        @if (showDefault) {
                          <app-custom-order-history-overview-table-default
                            [orders]="orders"
                            (cancelOrder)="onCancelOrder($event, confirmationDelete)"
                          ></app-custom-order-history-overview-table-default>
                        }
                      } @else {
                        <div [ngClass]="'cx-order-history-no-order row'">
                          <div [ngClass]="'col-sm-12 col-md-6 col-lg-4'">
                            <div>{{ 'customOrderHistory.noOrders' | cxTranslate }}</div>
                            <a
                              [routerLink]="{ cxRoute: 'home' } | cxUrl"
                              routerLinkActive="active"
                              class="btn btn-primary btn-block"
                              >{{ 'customOrderHistory.startShopping' | cxTranslate }}</a
                              >
                            </div>
                          </div>
                        }
                        <!-- NO ORDER CONTAINER -->
                      </div>
                    </div>
                  } @else {
                    <cx-spinner></cx-spinner>
                  }
                }

                <ng-template #confirmationDelete let-modal>
                  <div class="modal-header">
                    <h4 class="modal-title" id="modal-title">
                      {{ 'customOrderHistory.dialog.orderDelete.title' | cxTranslate }}
                    </h4>
                    <button
                      type="button"
                      class="close"
                      aria-describedby="modal-title"
                      (click)="modal.dismiss('Cross click')"
                      >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <p>
                      <strong>{{
                        'customOrderHistory.dialog.orderDelete.body' | cxTranslate
                      }}</strong>
                    </p>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="modal.dismiss('cancel click')"
                      >
                      {{ 'customOrderHistory.buttons.cancelText' | cxTranslate }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="modal.close('Ok click')"
                      >
                      {{ 'customOrderHistory.buttons.ok' | cxTranslate }}
                    </button>
                  </div>
                </ng-template>
